import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-header cursor-pointer bg-success" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0 text-light" }
const _hoisted_5 = { class: "card-body pt-9 pb-0" }
const _hoisted_6 = { class: "col-md-12 d-flex" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Parent Tranche", -1)
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_12 = { class: "row mb-7" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Tranche Number", -1)
const _hoisted_14 = { class: "col-lg-8" }
const _hoisted_15 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Tranche Label", -1)
const _hoisted_18 = { class: "col-lg-8 fv-row" }
const _hoisted_19 = { class: "fw-bold fs-6" }
const _hoisted_20 = { class: "row mb-7" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Short Name", -1)
const _hoisted_22 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 me-2" }, null, -1)
const _hoisted_24 = { class: "row mb-7" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Start Date", -1)
const _hoisted_26 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 me-2" }, null, -1)
const _hoisted_28 = { class: "row mb-7" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "End Date", -1)
const _hoisted_30 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_31 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_32 = { class: "row mb-7" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Donor Agencies", -1)
const _hoisted_34 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_35 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_36 = { class: "row mb-7" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Amount", -1)
const _hoisted_38 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_39 = { class: "fw-bolder fs-6 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, " Tranche Details for " + _toDisplayString(this.trancheDetails?.label), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(this.trancheDetails?.parent_tranche?.label), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(this.trancheDetails?.tranche_no), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(this.trancheDetails?.label), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createTextVNode(_toDisplayString(this.trancheDetails?.short_name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createTextVNode(_toDisplayString(this.trancheDetails.start_date), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, _toDisplayString(this.trancheDetails?.end_date), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(this.trancheDetails?.donor_agencies), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, _toDisplayString(this.trancheDetails?.amount), 1)
            ])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}